import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
// import fileDownload from 'js-file-download';
import * as _ from 'lodash';
import Button from 'components/inputs/Button';
import { useSelector, useDispatch } from 'react-redux';
import {
  // DOWNLOAD_INVOICE_B2C,
  GENERATE_EXCEL,
  QUERY_SAP_MONTHLY_DATA,
  GET_SIGNED_URL_FOR_EXCEL,
  DELETE_SAP_MONTHLY_DATA_RECORD
} from 'actions/sap';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { BiLoaderAlt, BiError } from 'react-icons/bi';
import { MdOutlineDownloading } from 'react-icons/md';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Modal } from 'react-bootstrap';
import DeleteModal from 'components/general/DeleteModal';
import { LuRefreshCw } from 'react-icons/lu';
import { Spinner } from 'react-bootstrap';


const DataValidation = ({ month }) => {

  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [id, setId] = React.useState('');
  const dispatch = useDispatch();
  const { isLoading: isLoader, page, limit, sapMonthlyDataForDownload } = useSelector((state) => state.sapMonthlyData);

  const { t } = useTranslation();

  const downloadInvoiceB2C = () => {
    dispatch({
      type: GENERATE_EXCEL.REQUEST,
      payload: { month: month, excel: true, report: 'invoiceB2C' },
      cb: (res) => {
        console.log('res', res);
        if (res) {
          if (_.get(res, 'status') === 200) {
            getDownloadInvoiceB2C({});
            const message = _.get(res, 'message');
            toast.success(message);
          } else {
            getDownloadInvoiceB2C({});
            const message = _.get(res, 'message');
            toast.error(message);
          }
        }
      },
    });
  };

  const getDownloadInvoiceB2C = () => {
    dispatch({
      type: QUERY_SAP_MONTHLY_DATA.REQUEST,
      payload: { month: month }
    })
  };

  const handleDownloadExcel = (url) => {
    dispatch({
      type: GET_SIGNED_URL_FOR_EXCEL.REQUEST,
      payload: { url },
      cb: (res) => {
        if (_.get(res, 'status') === 200) {
          toast.success("Download Completed")
          const url = _.get(res, 'data.presignedUrl', '');
          if (url) {
            window.open(url, '_self');
          } else {
            toast.success("URL Not Found")
          }
        }
      },
    });
  };

  const deleteSapMonthlyDataRecord = useCallback(() => {
    dispatch({
      type: DELETE_SAP_MONTHLY_DATA_RECORD.REQUEST,
      payload: id,
      cb: (res) => {
        if (_.get(res, 'status', '') === 200) {
          handleCloseDeleteModel();
          getDownloadInvoiceB2C({});
        }
      },
    })
  }, [id]);

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setId('');
  };

  React.useEffect(() => {
    getDownloadInvoiceB2C();
  }, []);


  const [isSpinning, setIsSpinning] = useState(false);

  const handleRefresh = () => {
    setIsSpinning(true);

    setTimeout(() => {
      setIsSpinning(false);
      getDownloadInvoiceB2C({});
    }, 500);
  };

  return (
    <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
      <div className="space-y-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3>
            <span>{isLoader ? <Skeleton height={15} width={100} /> : `Month: ${month}`}</span>
          </h3>
          <div className="d-flex align-items-center gap-4">
            {isLoader ? (
              <div className="loader--block">
                <Spinner as="span" animation="border" size="sm" role="status" />
              </div>
            ) :
              <Button onClick={downloadInvoiceB2C} className="report-download-button">
                {t('button.generateExcel')}
              </Button>
            }
            {/* &nbsp;&nbsp; */}
            <div className="report-excel-icon">
              <LuRefreshCw size={28} color={'#3c7cdd'} className={`${isSpinning ? 'spin' : ''} reload-icon`} onClick={handleRefresh} />
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="record-list-table" id="table-to-xls">
            <thead>
              <tr>
                <th>
                  <div className="sorting">
                    <span>{isLoader ? <Skeleton height={15} width={100} /> : t('faultyBookingReport.srNo')}</span>
                  </div>
                </th>
                <th style={{ textAlign: 'center' }}>
                  <span>{isLoader ? <Skeleton height={15} width={100} /> : t('downloadReports.month')}</span>
                </th>
                <th style={{ textAlign: 'center' }}>
                  <span>{isLoader ? <Skeleton height={15} width={100} /> : t('downloadReports.action')}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoader ? (
                <tr>
                  <td colSpan={9} className="border-0">
                    <div className="loader--block">
                      <Skeleton height={15} width={100} />
                    </div>
                  </td>
                </tr>
              ) : _.isEmpty(sapMonthlyDataForDownload) ? (
                <tr>
                  <td colSpan={10} className="border-0">
                    <div className="empty-data-block">No Records Found</div>
                  </td>
                </tr>
              ) : (
                _.map(sapMonthlyDataForDownload, (item, key) => {
                  const serial_num = limit * (page - 1) + key;

                  return (
                    <tr key={`faulty-booking-report-${serial_num}`}>
                      <td>{serial_num + 1}</td>
                      <td style={{ textAlign: 'center' }}>{_.get(item, 'month', '-')}</td>
                      <td style={{ textAlign: 'center' }}>
                        <>
                          <span className="ico">
                            <RiDeleteBinLine
                              size={30} color={'#be210b'}
                              title={_.get(item, 'reason')}
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setShowDeleteModal(true);
                                setId(_.get(item, 'id', ''));
                              }} />
                          </span>
                          &nbsp; &nbsp; &nbsp; &nbsp;
                        </>
                        {_.get(item, 'bucket.status') === 'pending' ? (
                          <BiLoaderAlt size={30} style={{ animation: 'spin 1s linear infinite' }} color={'#109b72'} />
                        ) : _.get(item, 'bucket.status') === 'success' ? (
                          <MdOutlineDownloading
                            size={30}
                            color={'#109b72'}
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleDownloadExcel(_.get(item, 'bucket.url'))}
                          />
                        ) : (
                          <BiError size={30} color={'#FFDF00'} title={_.get(item, 'bucket.reason')} />
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        {
          showDeleteModal && (
            <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
              <DeleteModal title={`${month} Month Record`} onClose={handleCloseDeleteModel} onRemove={deleteSapMonthlyDataRecord} />
            </Modal>
          )
        }
      </div>
    </SkeletonTheme>
  );
};

DataValidation.propTypes = {
  month: PropTypes.string.isRequired,
};

export default DataValidation;